// import vuetify - https://vuetifyjs.com/en/getting-started/installation/

import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import { aliases, md } from "vuetify/iconsets/md";
const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: "md",
    aliases,
    sets: {
      md,
    },
  },
  theme: {
    defaultTheme: "light",
    themes: {
      dark: {
        dark: true,
        colors: {
          primary: "#177398",
          secondary: "#00486a",
          accent: "#07B89B",
          anchor: "#092b3c",
        },
      },
      light: {
        dark: false,
        colors: {
          primary: "#177398",
          secondary: "#0EBD9D",
          accent: "#07B89B",
          anchor: "#092b3c",
        },
      },
    },
  },
});

export default vuetify;
